// extracted by mini-css-extract-plugin
module.exports = {"animate":"LoadingIcon_animate__Hg27L","rotate":"LoadingIcon_rotate__UL5Jg"};